import App from '@/App';
import { PrivateRoute } from '@/components/private-route/private-route';
import { PublicRoute } from '@/components/public-route/public-route';

import { Dashboard } from '@/pages/dashboard/dashboard';
import { ResetPassword } from '@/pages/reset-password/reset-password';
import { ForgotPassword } from '@/pages/forgot-password/forgot-password';
import { SignIn } from '@/pages/sign-in/sign-in';
import { Navigate, RouteObject } from 'react-router';
import { Surveys } from '@/pages/surveys/surveys';
import { Maintenances } from '@/pages/maintenances/maintenances';
import { Documents } from '@/pages/documents/documents';
import { DocumentDetails } from '@/pages/documents/document-details/document-details';
import { CreateDocumentPage } from '@/pages/documents/create-document/create-document';
import { Profile } from '@/pages/profile/profile';
import { NotFound } from '@/pages/not-found/not-found';
import { Conversations } from '@/pages/conversations/conversations';
import { Conversation } from '@/pages/conversations/conversation/conversation';
import { Company } from '@/pages/company/company';

const privateRoutesDefinition = [
  { path: '/', element: Dashboard },
  {
    path: 'conversations',
    element: Conversations,
    children: [{ path: ':callId', element: <Conversation /> }],
  },
  {
    path: 'surveys',
    element: Surveys,
  },
  {
    path: 'work-orders',
    element: Maintenances,
  },
  {
    path: 'documents',
    element: Documents,
    children: [
      { path: 'new', element: <CreateDocumentPage /> },
      { path: ':documentId', element: <DocumentDetails /> },
    ],
  },
  {
    path: 'company',
    element: Company,
  },
  {
    path: 'profile',
    element: Profile,
  },
];

const publicRoutesDefinition = [
  { path: 'sign-in', element: SignIn },
  { path: 'sign-up', element: 'sign-up' },
  { path: 'reset-password', element: ResetPassword },
  { path: 'forgot-password', element: ForgotPassword },
];

const privateRoutes = privateRoutesDefinition.map(
  ({ path, element: RouteComponent, children }) => ({
    path,
    element: (
      <PrivateRoute>
        <RouteComponent />
      </PrivateRoute>
    ),
    children,
  })
);

const publicRoutes = publicRoutesDefinition.map(({ path, element: RouteComponent }) => ({
  path,
  element: (
    <PublicRoute>
      <RouteComponent />
    </PublicRoute>
  ),
}));

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    errorElement: <Navigate to="/" />,
    children: [
      ...privateRoutes,
      ...publicRoutes,
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];
